import * as types from './actionTypes';
import videoService from '../services/videoService';
import { fetch, addTask } from 'domain-task';
import ToastrService from '../services/toastrService';
import moment from 'moment';

export function getVideo(videoID) {
    return (dispatch, getState) => {
        const existingVideo = getState().videos.selectedVideo;
        if(!existingVideo || existingVideo.Video.ID !== parseInt(videoID, 10)) {
            let fetchTask = videoService.getVideo(videoID)
                .then(video => {
                    if(video) {
                        dispatch({ type: types.GET_VIDEO, video });
                    }
                    return video;
                })
            addTask(fetchTask);
            return fetchTask;
        }
        else {
            return Promise.resolve(true);
        }
    };
}

function dispatchStatusUpdate(dispatch, type, status) {
    let loadingStatus = { status: status };
    dispatch({ type, loadingStatus });
}

export function getCharts(forceReload = false) {
    return (dispatch, getState) => {
        const state = getState();
        if(state.videos.charts.length == 0 || forceReload || new Date(state.videos.chartsLastLoaded) < moment().subtract(10, 'minutes')) {
            dispatchStatusUpdate(dispatch, types.GET_VIDEO_CHARTS_STATUS, 'LOADING');
            let fetchTask = videoService.getCharts()
                .then(charts => {
                    if(charts) {
                        dispatch({type: types.GET_VIDEO_CHARTS, charts});
                        dispatchStatusUpdate(dispatch, types.GET_VIDEO_CHARTS_STATUS, 'LOADED');
                    }
                    return charts;
                })
                .catch(error => {
                    dispatchStatusUpdate(dispatch, types.GET_VIDEO_CHARTS_STATUS, 'FAILED');
                });
            addTask(fetchTask);
        }
    };
}

export function playVideo(videoID){
    return function(dispatch) {
        return videoService.playVideo(videoID).then(video => {
            dispatch({ type: types.PLAY_VIDEO, video });
        }).catch(error => {
            throw(error);
        });
    };
}

export function increaseVideoRating(videoID, currentProfileID){
    return function(dispatch) {
        return videoService.increaseRating(videoID, currentProfileID).then(rating => {
            dispatchRatingChange(dispatch, videoID, rating, currentProfileID);
            const toastrService = new ToastrService;
            toastrService.showSuccess('', 'Thanks for rating this video!');     
            return rating;     
        }).catch(error => {
            if(error.message.indexOf('hasn\'t been played') > -1) {
                swal('Here\'s how it works...', 'Watch a video and if you like it, click the turn me up button to increase the LoudUp rating!', {
                    button: "Ok, got it!",
                  });
            }
            else {
                const toastrService = new ToastrService;
                toastrService.showError('', error.message);
            }
            throw(error);
        });
    };
}

function dispatchRatingChange(dispatch, videoID, rating, currentProfileID) {
    const videoRating = { id: videoID, rating: rating.Rating, currentProfileID, videoProfileID: rating.RoleID };
    dispatch({ type: types.UPDATE_VIDEO_RATING, videoRating });
    const roleRating = { id: rating.RoleID, rating: rating.RoleRating }
    dispatch({ type: types.UPDATE_ROLE_RATING, roleRating });
    //reload the charts
    dispatch(getCharts(true));
}

export function decreaseVideoRating(videoID, currentProfileID){
    return function(dispatch) {
        return videoService.decreaseRating(videoID, currentProfileID).then(rating => {
           dispatchRatingChange(dispatch, videoID, rating, currentProfileID);   
           const toastrService = new ToastrService;
           toastrService.showSuccess('', 'You have removed your rating!'); 
           return rating;           
        }).catch(error => {
            const toastrService = new ToastrService;
            toastrService.showError('', 'Sorry, something went wrong, unable to remove video rating');
            throw(error);
        });
    };
}